/* eslint-disable */
require("script-loader!file-saver");
import XLSX from "xlsx-style-rows";
//https://github.com/wish4129/js-xlsx

/* eslint-disable */
import jsPDF from "jspdf";
import jsPDFOtro from "jspdf-autotable";

function generateArray(table) {
  var out = [];
  var rows = table.querySelectorAll("tbody tr");
  var ranges = [];
  for (var R = 0; R < rows.length; ++R) {
    var outRow = [];
    var row = rows[R];
    var columns = row.querySelectorAll("td,th");

    for (var C = 0; C < columns.length; ++C) {
      var cell = columns[C];
      var classes = cell.getAttribute("class");
      if (classes != null && classes.indexOf("noexport") !== -1) continue;

      var colspan = cell.getAttribute("colspan") * 1;
      var rowspan = cell.getAttribute("rowspan") * 1;

      var cellValue =
        cell.tagName == "TH" ? "$$" + cell.innerText : cell.innerText;

      if (cellValue !== "" && cellValue == +cellValue) cellValue = +cellValue;

      //Skip ranges
      ranges.forEach(function(range) {
        if (
          R >= range.s.r &&
          R <= range.e.r &&
          outRow.length >= range.s.c &&
          outRow.length <= range.e.c
        ) {
          for (var i = 0; i <= range.e.c - range.s.c; ++i) outRow.push(null);
        }
      });

      //Handle Row Span
      if (rowspan || colspan) {
        rowspan = rowspan || 1;
        colspan = colspan || 1;
        ranges.push({
          s: {
            r: R,
            c: outRow.length
          },
          e: {
            r: R + rowspan - 1,
            c: outRow.length + colspan - 1
          }
        });
      }

      //Handle Value
      outRow.push(cellValue !== "" ? cellValue : null);

      //Handle Colspan
      if (colspan) for (var k = 0; k < colspan - 1; ++k) outRow.push(null);
    }
    out.push(outRow);
  }
  return [out, ranges];
}

function datenum(v, date1904) {
  if (date1904) v += 1462;
  var epoch = Date.parse(v);
  return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}

function numerifica(v) {
  try {
    if ((v + "").trim().indexOf(",") != -1) {
      let v2 = (v + "").trim() + "";

      if (v2.match(/^[0-9\-\,]+$/)) {
        return v2.replace(/\./g, "").replace(/\,/g, ".") * 1.0;
      }
    }
  } catch (err) {}
  return v;
}

function sheet_from_array_of_arrays(data, opts) {
  var ws = {};
  var range = {
    s: {
      c: 10000000,
      r: 10000000
    },
    e: {
      c: 0,
      r: 0
    }
  };
  if (data)
    for (var R = 0; R != data.length; ++R) {
      for (var C = 0; C != data[R].length; ++C) {
        if (range.s.r > R) range.s.r = R;
        if (range.s.c > C) range.s.c = C;
        if (range.e.r < R) range.e.r = R;
        if (range.e.c < C) range.e.c = C;
        var cell = {
          v: data[R][C]
        };

        if (cell.v != null && (cell.v + "").substr(0, 2) == "$$") {
          cell.v = cell.v.substr(2).toUpperCase();
          cell.s = {
            fill: {
              fgColor: { rgb: "FFDDDDDD" }
            }
          };
        }

        if (cell.v != null) cell.v = numerifica(cell.v);
        //cell.s= {fill:{patternType:'solid', fgColor: {rgb:"86BC25"}}};

        if (cell.v == null) continue;

        var cell_ref = XLSX.utils.encode_cell({
          c: C,
          r: R
        });

        if (typeof cell.v === "number") cell.t = "n";
        else if (typeof cell.v === "boolean") cell.t = "b";
        else if (cell.v instanceof Date) {
          cell.t = "n";
          cell.z = XLSX.SSF._table[14];
          cell.v = datenum(cell.v);
        } else cell.t = "s";

        ws[cell_ref] = cell;
      }
    }
  if (range.s.c < 10000000) ws["!ref"] = XLSX.utils.encode_range(range);
  return ws;
}

function Workbook() {
  if (!(this instanceof Workbook)) return new Workbook();
  this.SheetNames = [];
  this.Sheets = {};
}

function s2ab(s) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
  return buf;
}

export function export_table_to_excel(
  id = null,
  tableref = null,
  headersOfTable = null,
  filename = "excel",
  all = null
) {
  var data = all;
  var theTable;
  if (tableref || id) {
    theTable = id != null ? document.getElementById(id) : tableref;

    let sus = theTable.getElementsByClassName("noexportdata");
    //console.log("ELms", sus);
    for (let s of sus) {
      s.style.display = "none";
    }
    sus = theTable.getElementsByClassName("onlyexport");
    for (let s of sus) {
      s.style.display = "";
    }
    var oo = generateArray(theTable);
    var ranges = oo[1];

    /* original data */
    data = oo[0];
  }
  if (all != null) data = all;

  if (headersOfTable != null)
    data.unshift(headersOfTable.map(v => v.toUpperCase()));

  var ws_name = "Planilha1";

  var wb = new Workbook(),
    ws = sheet_from_array_of_arrays(data);

  autoWidth(data, ws);

  /* add ranges to worksheet */
  // ws['!cols'] = ['apple', 'banan'];
  ws["!merges"] = ranges;

  /* add worksheet to workbook */
  wb.SheetNames.push(ws_name);
  wb.Sheets[ws_name] = ws;

  //wb = XLSX.utils.table_to_book(theTable);

  if (theTable) {
    let sus = theTable.getElementsByClassName("noexportdata");
    for (let s of sus) {
      s.style.display = "";
    }

    sus = theTable.getElementsByClassName("onlyexport");
    for (let s of sus) {
      s.style.display = "none";
    }
  }

  var wbout = XLSX.write(wb, {
    bookType: "xlsx",
    bookSST: false,
    type: "binary"
  });

  saveAs(
    new Blob([s2ab(wbout)], {
      type: "application/octet-stream"
    }),
    filename + ".xlsx"
  );
}

export function export_table_to_csv(
  id = null,
  tableref = null,
  headersOfTable = null,
  filename = "csv",
  all = null
) {
  var theTable = id != null ? document.getElementById(id) : tableref;
  var oo = generateArray(theTable);

  var ranges = oo[1];

  /* original data */

  var data = oo[0];
  if (all != null) data = all;

  data = data.map(v => v.map(c => (c + "").replace(/\n/g, " ").trim()));

  if (headersOfTable != null)
    data.unshift(headersOfTable.map(v => v.toUpperCase()));

  var wb = new Workbook(),
    ws = sheet_from_array_of_arrays(data);

  var csv = XLSX.utils.sheet_to_csv(ws, {
    FS: ";",
    strip: true
  });
  saveAs(
    new Blob([s2ab(csv)], {
      type: "application/octet-stream"
    }),
    filename + ".csv"
  );
}

export function export_table_to_json(
  id = null,
  tableref = null,
  headersOfTable = null,
  filename = "json",
  all = null
) {
  var theTable = id != null ? document.getElementById(id) : tableref;
  var oo = generateArray(theTable);

  var ranges = oo[1];

  /* original data */

  var data = oo[0];
  if (all != null) data = all;

  data = data.map(v => v.map(c => (c + "").replace(/\n/g, " ").trim()));

  if (headersOfTable != null)
    data.unshift(
      headersOfTable.map(v =>
        global.fn.meta_remove_acentos(v.toLowerCase(), "_")
      )
    );

  var wb = new Workbook(),
    ws = sheet_from_array_of_arrays(data);

  var csv = XLSX.utils.sheet_to_json(ws, {
    raw: false,
    defval: ""
  });

  saveAs(
    new Blob([JSON.stringify(csv, true, 4)], {
      type: "application/json"
    }),
    filename + ".json"
  );
}

export function export_table_to_pdf(
  id = null,
  tableref = null,
  headersOfTable = null,
  filename = "json",
  all = null
) {
  var theTable = id != null ? document.getElementById(id) : tableref;
  var oo = generateArray(theTable);

  var ranges = oo[1];

  /* original data */

  var data = oo[0];
  if (all != null) data = all;

  data = data.map(v => v.map(c => (c + "").replace(/\n/g, " ").trim()));

  var doc = new jsPDF();

  var col = headersOfTable;
  var rows = data;

  doc.autoTable(col, rows, {
    margin: {
      top: 20
    },
    addPageContent: function(data) {
      doc.text(filename, 15, 15);
    }
  });

  doc.save(filename + ".pdf");
}

export function autoWidth(data, ws) {
  /*设置worksheet每列的最大宽度*/
  const colWidth = data.map(row =>
    row.map(val => {
      /*先判断是否为null/undefined*/
      if (val == null) {
        return {
          wch: 10
        };
      } else if (val.toString().charCodeAt(0) > 255) {
        /*再判断是否为中文*/
        return {
          wch: val.toString().length * 2
        };
      } else {
        return {
          wch: val.toString().length
        };
      }
    })
  );
  /*以第一行为初始值*/
  let result = colWidth[0];
  for (let i = 1; i < colWidth.length; i++) {
    for (let j = 0; j < colWidth[i].length; j++) {
      if (colWidth[i][j] && result[j])
        if (result[j]["wch"] < colWidth[i][j]["wch"]) {
          result[j]["wch"] = colWidth[i][j]["wch"];

          if (result[j]["wch"] > 50) result[j]["wch"] = 50;
        }
    }
  }
  ws["!cols"] = result;
}

export function export_json_to_excel({
  header,
  data,
  filename,
  autoWidth = true,
  bookType = "xlsx"
} = {}) {
  /* original data */
  filename = filename || "excel-list";
  data = [...data];
  data.unshift(header);
  var ws_name = "SheetJS";
  var wb = new Workbook(),
    ws = sheet_from_array_of_arrays(data);

  if (autoWidth) {
    /*设置worksheet每列的最大宽度*/
    const colWidth = data.map(row =>
      row.map(val => {
        /*先判断是否为null/undefined*/
        if (val == null) {
          return {
            wch: 10
          };
        } else if (val.toString().charCodeAt(0) > 255) {
          /*再判断是否为中文*/
          return {
            wch: val.toString().length * 2
          };
        } else {
          return {
            wch: val.toString().length
          };
        }
      })
    );
    /*以第一行为初始值*/
    let result = colWidth[0];
    for (let i = 1; i < colWidth.length; i++) {
      for (let j = 0; j < colWidth[i].length; j++) {
        if (colWidth[i][j] && result[j])
          if (result[j]["wch"] < colWidth[i][j]["wch"]) {
            result[j]["wch"] = colWidth[i][j]["wch"];
          }
      }
    }
    ws["!cols"] = result;
  }

  /* add worksheet to workbook */
  wb.SheetNames.push(ws_name);
  wb.Sheets[ws_name] = ws;

  var wbout = XLSX.write(wb, {
    bookType: bookType,
    bookSST: false,
    type: "binary"
  });
  saveAs(
    new Blob([s2ab(wbout)], {
      type: "application/octet-stream"
    }),
    `${filename}.${bookType}`
  );
}
